import { useAppSelector } from '../../../app/hooks'
import {
  canUseThreeInspectionReport,
  THREE_INSPECTION_CONFIG_KEY
} from '../domain/accessConfig'

/**
 * 判断当前团队是否命中三检记录表远程灰度配置。
 * 由路由门禁和照片操作入口共同调用，团队或 KV 变化时自动重新计算。
 *
 * @returns 当前团队是否可以访问三检记录表
 */
export function useThreeInspectionAccess(): boolean {
  const rawConfig = useAppSelector(
    (state) =>
      (state.main.config as Record<string, string | undefined>)?.[
        THREE_INSPECTION_CONFIG_KEY
      ]
  )
  const inviteID = useAppSelector((state) => state.group.invite_id)
  const groupID = useAppSelector((state) => state.group.groupId)

  return canUseThreeInspectionReport(rawConfig, inviteID, groupID)
}
